<template>
  <div class="main">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  components: {},
  computed: {
    ...mapGetters({
      currentLanguage: "currentLanguage"
    })
  },
  watch: {
    currentLanguage: {
      immediate: true,
      handler(n, o) {
        if (n == "1") {
          this.$i18n.locale = "zh-CN";
        } else {
          this.$i18n.locale = "en-US";
        }
      }
    }
  },
  created() {},
  updated() {},
  mounted() {},
  methods: {}
};
</script>
<style type="text/css" lang="less">
// 密码框的隐藏、显示
// .has-pwd-form {
//   .el-form-item {
//     position: relative;
//     .el-icon-view {
//       cursor: pointer;
//       position: absolute;
//       right: 30px;
//       top: 50%;
//       transform: translateY(-50%);
//       color: #888;
//       font-size: 18px;
//       &.show {
//         color: #333;
//         font-size: 20px;
//       }
//     }
//   }
// }

// 信息面板
.panel-item {
  margin-bottom: 30px;
  .item-title {
    position: relative;
    padding-left: 30px;
    margin-bottom: 30px;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 20px;
      background-color: #409eff;
    }
    h3 {
      color: #409eff;
    }
  }
  .item-content {
    display: flex;
    flex-wrap: wrap;
    padding: 0 0 20px 30px;
    .content {
      width: 50%;
      margin: 5px 0;
      .name {
        display: inline-block;
        width: 120px;
        box-sizing: border-box;
        padding-right: 20px;
        text-align: right;
      }
      .value {
        display: inline-block;
        width: calc(100% - 160px);
        border-bottom: 1px solid #dcdfe6;
        padding: 5px 0;
      }
    }
  }
}

// 弹框
.dialog-custom {
  .dialog-header {
    text-align: center;
  }
  .dialog-body {
    .form-line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-form-item {
        width: 33.33%;
        .el-select {
          width: 100%;
        }
      }
    }
  }
  .dialog-footer {
    text-align: center;
  }
}

// 分页容器
.pagination-wrap {
  margin-top: 25px;
  text-align: right;
}

// 表格右端固定操作容器
.operation-wrap {
  margin-bottom: 25px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  &.table {
    margin: 0;
    justify-content: flex-start;
  }
  i {
    margin-right: 4px;
  }
}
</style>

<style type="text/css" lang="less" scope>
.main {
  position: relative;
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 1800px) {
}
@media screen and (min-width: 1801px) {
}
</style>



// WEBPACK FOOTER //
// src/App.vue